// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-card {
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  transition: transform 0.3s;
  cursor: pointer;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  font-size: 2rem;
  color: #fff;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: #28a745;
  width: 50px;
  height: 50px;
}

.card-title {
  font-size: 18px;
  color: rgb(72, 71, 71);
}

.title {
  color: rgb(104, 104, 104);
  font-size: 24px;
}

.dashboard-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.card {
  flex: 1;
  min-width: 280px;
  padding: 16px;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  border-radius: 8px;
  background-color: #fff;
}

.card h2 {
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 16px;
}

#aptsiTable {
  overflow-y: auto;
  height: 400px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/auth-tool-home/auth-tool-home.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,2CAAA;EACA,0BAAA;EACA,eAAA;AACJ;;AACE;EACE,2BAAA;AAEJ;;AAAE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AACE;EACE,eAAA;EACA,sBAAA;AAEJ;;AACE;EACE,yBAAA;EACA,eAAA;AAEJ;;AAgBA;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAbJ;;AAgBE;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,sBAAA;AAbJ;;AAkBE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;;AAkBE;EACE,gBAAA;EACA,aAAA;AAfJ","sourcesContent":[".summary-card {\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\r\n    transition: transform 0.3s;\r\n    cursor: pointer;\r\n  }\r\n  .summary-card:hover {\r\n    transform: translateY(-5px);\r\n  }\r\n  .card-icon {\r\n    font-size: 2rem;\r\n    color: #fff;\r\n    padding: 0.5rem;\r\n    border-radius: 50%;\r\n    background-color:  #28a745;\r\n    width: 50px;\r\n    height: 50px;\r\n    \r\n  }\r\n\r\n  .card-title{\r\n    font-size: 18px;\r\n    color: rgb(72, 71, 71);\r\n  }\r\n  \r\n  .title{\r\n    color: rgb(104, 104, 104);\r\n    font-size: 24px;\r\n  }\r\n//   .chart-card,\r\n//   .table-card {\r\n//     flex: 1 1 48%; /* Grow, shrink, and set basis to 48% for equal spacing */\r\n//     max-width: 48%; /* Prevent cards from exceeding 48% of the container */\r\n//     height: 300px;\r\n\r\n//   }\r\n  \r\n//   /* Prevent overflow in case of smaller screens */\r\n//   @media (max-width: 768px) {\r\n//     .chart-card,\r\n//     .table-card {\r\n//       flex: 1 1 100%; /* Stack cards on smaller screens */\r\n//       max-width: 100%; /* Full width for small devices */\r\n//     }\r\n//   }\r\n.dashboard-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 16px;\r\n  }\r\n\r\n  .card {\r\n    flex: 1;\r\n    min-width: 280px;\r\n    padding: 16px;\r\n    box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\r\n    border-radius: 8px;\r\n    background-color: #fff;\r\n    // border-color:#023879;;\r\n    \r\n  }\r\n\r\n  .card h2 {\r\n    font-size: 1.25rem;\r\n    font-weight: 500;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  #aptsiTable{\r\n    overflow-y: auto;\r\n    height: 400px;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
